export function Join(...classes: (string | boolean | undefined | null)[]) {
  return classes.filter(Boolean).join(' ')
}
